<template>
  <button
      class="translation-btn h-full flex items-center gap-1.5 transition-all"
      @click="onOpenTranslationModal">
    <div class="w-full h-full flex justify-center items-center relative">
      <GrmIcon :icon="`menu-translation-${translationState ? 'on' : 'off'}`" size="full"
               :class="[
                  'z-10',
                   // {'animate-ping': translationState}
               ]"
      />
    </div>
  </button>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RoomTranslation from "@/components/Room/ExtendMenu/RoomTranslation/RoomTranslation.vue";
import GrmIcon from "@/components/Common/icon/GrmIcon.vue";

export default {
  name: "BtnTranslation",
  components: {
    GrmIcon
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('user', ['hasEmceeRole']),
    ...mapGetters('translation', ['translationState']),
  },
  methods: {
    ...mapActions('translation', ['enableTranslation']),
    onOpenTranslationModal() {
      if (this.translationState) {
        this.enableTranslation({ enable: false })
      } else {
        this.$modal(RoomTranslation);
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.translation-btn {
  width: 55px;
  &:hover {
    background-color: #0000007F;
  }
}

</style>